import React, { forwardRef } from 'react';

export const AddItemIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_28712_22362)">
        <rect
          x="2"
          width="30"
          height="30"
          rx="15"
          fill="white"
          className={'group-hover:fill-[#7A6BE51A]'}
        />
        <rect
          x="2.5"
          y="0.5"
          width="29"
          height="29"
          rx="14.5"
          stroke="#7A6BE5"
          strokeOpacity="0.3"
        />
        <path
          d="M23 16.8571H17.8571V22H16.1429V16.8571H11V15.1429H16.1429V10H17.8571V15.1429H23V16.8571Z"
          fill="#7A6BE5"
        />
        <path
          d="M17.3574 10.5V15.6426H22.5V16.3574H17.3574V21.5H16.6426V16.3574H11.5V15.6426H16.6426V10.5H17.3574Z"
          stroke="#7A6BE5"
          strokeOpacity="0.3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_28712_22362"
          x="0"
          y="0"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.478431 0 0 0 0 0.419608 0 0 0 0 0.898039 0 0 0 0.3 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_28712_22362" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_28712_22362"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
);
